import { storeToRefs } from "pinia";
import { ref } from "vue";
import { useDossierStore } from "./useDossierStore";
import { useDossierDataStore } from "./useDossierDataStore";
import { getCombinedCustomerNames } from "@/helpers/inventarisation/customers";

export default function useAddCustomerToDossier() {
	const state = ref<{ fullname?: string; email?: string }>({});

	const { selectedDossier } = storeToRefs(useDossierStore());
	const { data } = storeToRefs(useDossierDataStore());
	state.value.fullname =
		getCombinedCustomerNames(data.value.customers ?? []) ??
		selectedDossier.value?.name ??
		"";

	return { state };
}
